import { UserService } from '../../services/user.service';
import { CompanyStatus } from '../../../models/common';
var InactiveAccountComponent = /** @class */ (function () {
    function InactiveAccountComponent(_userService) {
        this._userService = _userService;
        this.billingPageLink = '/account-settings/billing';
        this.billingMode = _userService.isAgency;
        this.supportMode = _userService.isAdvertiser;
        this.adminMode = _userService.isAdmin || _userService.isAnalyst;
    }
    Object.defineProperty(InactiveAccountComponent.prototype, "isSsoUser", {
        get: function () {
            return this._userService.isSsoUser;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InactiveAccountComponent.prototype, "isFutureAccount", {
        get: function () {
            var currentAdvertiser = this._userService.getCurrentAdvertiser();
            return currentAdvertiser && currentAdvertiser.status === CompanyStatus.FUTURE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InactiveAccountComponent.prototype, "startDate", {
        get: function () {
            var currentAdvertiser = this._userService.getCurrentAdvertiser();
            return currentAdvertiser && currentAdvertiser.startDate;
        },
        enumerable: true,
        configurable: true
    });
    InactiveAccountComponent.prototype.contactSupport = function () {
        this._userService.contactSupport();
    };
    return InactiveAccountComponent;
}());
export { InactiveAccountComponent };



// WEBPACK FOOTER //
// ./src/app/auth/inactive-account/inactive-account.component.ts.pre-build-optimizer.js